module.exports = {"370212001":"中韩街道","370212002":"沙子口街道","370212003":"王哥庄街道","370212004":"北宅街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370212.json
// module id = 1263
// module chunks = 0